import React from 'react';
import styles from '../ReportCard.module.scss';

/**
 * Модальное окно QR-сканера с камерой / фото / отправкой.
 */
const ScannerOverlay = ({
  isGuard,
  scanningStep,
  capturedPhoto,
  videoRef,
  canvasRef,
  switchCamera,
  selectCamera,
  availableCameras,
  currentCameraInfo,
  isCameraLoading,
  capturePhoto,
  retakePhoto,
  handleSendPhoto,
  handleCloseScanner,
}) => {
  return (
    <div className={styles.qrScannerOverlay}>
      <div className={styles.qrScannerModal}>
        {/* Верхняя панель */}
        <div className={styles.qrScannerHeader}>
          <div className={styles.headerLeft}>
            {!isGuard && (
              <div className={styles.scanningSteps}>
                <div className={`${styles.stepBadge} ${scanningStep === 'scan' ? styles.active : (scanningStep !== 'scan' ? styles.completed : '')}`}>1</div>
                <div className={styles.stepDivider} />
                <div className={`${styles.stepBadge} ${scanningStep === 'photo' ? styles.active : (scanningStep === 'review' || scanningStep === 'sending' ? styles.completed : '')}`}>2</div>
              </div>
            )}
            <h3>
              {scanningStep === 'scan' && 'СКАНИРОВАНИЕ QR'}
              {scanningStep === 'photo' && 'ФОТО ТРАНСПОРТА'}
              {scanningStep === 'review' && 'ПРОВЕРКА ФОТО'}
              {scanningStep === 'sending' && 'ОТПРАВКА...'}
            </h3>
          </div>
          <button onClick={handleCloseScanner} className={styles.closeButton}>✕</button>
        </div>

        {/* Область камеры */}
        <div className={styles.qrScannerBody}>
          {scanningStep === 'review' && capturedPhoto ? (
            <img src={capturedPhoto} alt="Превью" className={styles.photoPreview} />
          ) : (
            <div className={styles.videoContainer}>
              <video ref={videoRef} className={styles.qrVideo} playsInline muted autoPlay />
              <canvas ref={canvasRef} style={{ display: 'none' }} />
              {scanningStep === 'scan' && (
                <div className={styles.qrOverlay}>
                  <div className={styles.qrFrame} />
                </div>
              )}
            </div>
          )}
        </div>

        {/* Нижняя панель управления */}
        <div className={styles.qrScannerFooter}>
          {scanningStep === 'scan' && (
            <>
              {/* Список доступных камер (иконки) */}
              {availableCameras && availableCameras.length > 0 && (
                <div style={{ display: 'flex', justifyContent: 'center', gap: '15px', marginBottom: '15px', flexWrap: 'wrap' }}>
                  {availableCameras.map((cam, idx) => {
                    const isActive = currentCameraInfo?.deviceId === cam.deviceId;
                    return (
                      <button
                        key={cam.deviceId}
                        onClick={() => selectCamera(cam.deviceId)}
                        disabled={isCameraLoading}
                        style={{
                          background: isActive ? '#4caf50' : '#333',
                          border: isActive ? '2px solid #fff' : '1px solid #555',
                          borderRadius: '50%',
                          width: '50px',
                          height: '50px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: isCameraLoading ? 'not-allowed' : 'pointer',
                          opacity: isCameraLoading ? 0.6 : 1,
                          color: '#fff',
                          fontSize: '24px',
                          position: 'relative',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.5)',
                          transition: 'all 0.2s',
                        }}
                        title={cam.label || `Камера ${idx + 1}`}
                      >
                        📷
                        <span style={{
                          position: 'absolute',
                          bottom: '-2px',
                          right: '-2px',
                          background: '#000',
                          borderRadius: '50%',
                          fontSize: '10px',
                          fontWeight: 'bold',
                          width: '18px',
                          height: '18px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          border: '1px solid #777'
                        }}>
                          {idx + 1}
                        </span>
                      </button>
                    );
                  })}
                </div>
              )}
              
              {isCameraLoading ? (
                 <p className={styles.qrHint} style={{ color: '#aaa' }}>⌛ Идет подключение к камере...</p>
              ) : (
                 <p className={styles.qrHint}>Наведите камеру на QR-код</p>
              )}

              <div className={styles.footerActions}>
                <button onClick={switchCamera} disabled={isCameraLoading} className={styles.btn_switch_camera}>⟳</button>
                <button onClick={handleCloseScanner} className={styles.btn_close_scanner}>Закрыть</button>
              </div>
            </>
          )}

          {scanningStep === 'photo' && (
            <>
              <p className={styles.qrHint}>Направьте камеру на транспорт</p>
              <button onClick={capturePhoto} className={styles.capturePhotoBtn}>СФОТОГРАФИРОВАТЬ</button>
            </>
          )}

          {scanningStep === 'review' && (
            <div className={styles.photoActions}>
              <button onClick={retakePhoto} className={styles.retakePhotoBtn}>↺ Переснять</button>
              <button
                onClick={handleSendPhoto}
                disabled={scanningStep === 'sending'}
                className={styles.sendPhotoBtn}
              >
                {scanningStep === 'sending' ? '⏳ Отправка...' : '✓ Отправить'}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(ScannerOverlay);
